import React from 'react';
import PropTypes from 'prop-types';
import Login from './Login';
import {connect} from 'react-redux';
import {setUser} from "actions/user";
import {generateUrl, routes} from "helpers/routes";
import {Redirect} from "react-router-dom";
import {graphql, compose} from "react-apollo";
import LoginMutation from 'gql/login.gql';
import queryString from 'query-string';
import moment from "moment";
import {getStatusFromError} from "helpers/errors";

class LoginProvider extends React.Component {
    static propTypes = {
        onSetUser: PropTypes.func.isRequired,
        user: PropTypes.object,
        login: PropTypes.func.isRequired,
        location: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);

        this.login = this.login.bind(this);
    }

    componentWillMount() {
        this.setState({
            status: null,
            processing: false
        });
    }

    login(credentials) {
        this.setState({processing: true});

        this.props.login({
            variables: {
                email: credentials.email,
                password: credentials.password,
            }
        }).then(({data}) => {
            const login = data.operatorLogin;
            const user = {
                accessToken: login.token.accessToken,
                refreshToken: login.token.refreshToken,
                expiresAt:  moment().add(parseInt(login.token.expiresIn, 10), 'seconds').unix(),
                id: login.operator.id,
            };
            this.props.onSetUser(user);
        }).catch(error => {
            this.setState({
                processing: false,
                status: getStatusFromError(error),
            });
        });
    }

    render() {
        const {user, location} = this.props;
        const {status} = this.state;

        if (user) {
            const query = queryString.parse(location.query);
            const target = query.redirect ? query.redirect : generateUrl(routes.homepage);

            return <Redirect to={target}/>
        }

        return <Login loading={this.state.processing} status={status} onFormSubmit={this.login}/>
    }
}

const mapStateToProps = state => ({
    user: state.user,
});

const mapDispatchToProps = dispatch => ({
    onSetUser: user => dispatch(setUser(user)),
});

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps
    ),
    graphql(LoginMutation, {name: 'login'})
)(LoginProvider);


// WEBPACK FOOTER //
// ./src/containers/Login/index.jsx